export type ShareInvitationStatus = 'PENDING' | 'ACCEPTED' | 'DECLINED' | 'REVOKED' | 'EXPIRED';

export interface DocumentShareInvitation {
  id: number;
  sourceUsername: string;
  targetUsername?: string;
  sourceDocumentName: string;
  message?: string;
  status: ShareInvitationStatus;
  createdAt: string;
  expiresAt?: string;
  respondedAt?: string;
  acceptedDocumentName?: string;
}

export interface AcceptShareResponse {
  id: number;
  name: string;
  categoryId: string;
}

export function isShareInvitationExpired(inv: DocumentShareInvitation): boolean {
  if (!inv.expiresAt) return false;
  return new Date(inv.expiresAt).getTime() < Date.now();
}

export function filterPendingIncomingShares(invitations: DocumentShareInvitation[]): DocumentShareInvitation[] {
  return invitations.filter((inv) => inv.status === 'PENDING' && !isShareInvitationExpired(inv));
}

export function filterPendingOutgoingShares(invitations: DocumentShareInvitation[]): DocumentShareInvitation[] {
  return invitations.filter((inv) => inv.status === 'PENDING' && !isShareInvitationExpired(inv));
}
